import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

FormTemplate.propTypes = {
  title: PropTypes.node,
  subtitle: PropTypes.node,
  alert: PropTypes.node,
  body: PropTypes.node,
  footer: PropTypes.node,
  onClose: PropTypes.func,
  onPrevious: PropTypes.func,
  showClose: PropTypes.bool,
  header: PropTypes.node,
  navigation: PropTypes.node,
  className: PropTypes.string,
  backButtonText: PropTypes.string
};

FormTemplate.defaultProps = {
  showClose: true
};

export default function FormTemplate(props) {
  const {
    header,
    navigation,
    title,
    subtitle,
    alert,
    body,
    footer,
    onPrevious,
    className,
    backButtonText = 'Back'
  } = props;

  return (
    <div className={classNames(
      'my-0 pt-4 lg:my-32x',
      className
    )}>
      {header}
      <div className="px-6 pb-0 lg:px-24">
        {navigation && (
          <div className="flex items-center justify-between mb-12">
            {React.cloneElement(navigation, { v2: true })}
          </div>
        )}
        {title && (
          <h5 className="text-3xl font-semibold text-cs-gray-900 text-left m-auto">
            {title}
          </h5>
        )}
        {subtitle ? (
          <h6 className="text-lg font-normal mt-2 text-cs-gray-700 text-left">
            {subtitle}
          </h6>
        ) : null}
      </div>
      <div className={classNames(
        (title || subtitle) && 'pt-16',
        'px-6 pb-0 lg:px-24'
      )}>
        {body}
      </div>
      {alert}
      {footer ? (
        <div className="flex items-center justify-start pt-16 px-10 md:px-24">
          {onPrevious && (
            <div className="text-cs-orange-500 underline cursor-pointer mr-8 sm:mr-12" onClick={onPrevious}>
              {backButtonText}
            </div>
          )}
          {footer}
        </div>
      ) : null}
    </div>
  );
}
